import { ActionButton, Box, Divider } from "@luce/ui";

import { usePackageDetailContext } from "../package-detail-context";

interface PackageActionsProps {
  onEditAddress: () => void;
  onModifyPlan: () => void;
}

export function PackageActions({ onEditAddress, onModifyPlan }: PackageActionsProps) {
  const { isActive } = usePackageDetailContext();

  if (!isActive) return null;

  return (
    <>
      <Divider />
      {/* Each tile takes half the row, as Figma draws it; their own 8px padding
          plus the row's 8px keeps the row 82px tall */}
      <Box className="py-spacing-sm flex flex-row">
        <ActionButton
          icon="MapPinSimpleArea"
          label="Edit Address"
          onClick={onEditAddress}
          size="md"
          className="flex-1"
        />
        <ActionButton
          icon="NotePencil"
          label="Modify Plan"
          onClick={onModifyPlan}
          size="md"
          className="flex-1"
        />
      </Box>
    </>
  );
}
